var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettingsSectionContainer',[_c('SettingsSectionDetails',{attrs:{"title":_vm.title,"description":_vm.description}}),_c('ELYXToggleButton',{attrs:{"isEnabled":_vm.isEnabled},on:{"click":_vm.toggleButtonClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }